import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChevronDown } from '@outdoor-voices/ui';
import { useRef } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Hero.module.scss';
import Image from '../Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero(_ref) {
  var cta = _ref.cta,
      imageDesktop = _ref.imageDesktop,
      imageMobile = _ref.imageMobile,
      message = _ref.message,
      title = _ref.title;
  var rootRef = useRef(null);

  var scrollDown = function scrollDown() {
    var rootEl = rootRef.current;
    var top = rootEl.offsetHeight + 36; // add top banner height

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    return true;
  };

  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    ref: rootRef,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageDesktop), {}, {
      className: cc([css.image, css.desktop])
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageMobile), {}, {
      className: cc([css.image, css.mobile])
    })), /*#__PURE__*/_jsxs("div", {
      className: css.copy,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.message,
        children: message
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.spacer, css.mobile])
      }), /*#__PURE__*/_jsxs("button", {
        className: css.cta,
        onClick: scrollDown,
        type: "button",
        children: [cta, /*#__PURE__*/_jsx(ChevronDown, {})]
      })]
    })]
  });
};

Hero.propTypes = {
  cta: PropTypes.string.isRequired,
  imageDesktop: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageMobile: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default Hero;